<!-- Modal Backdrop -->
<div class="modal-backdrop fade show" *ngIf="showModal"></div>

<!-- Main Modal -->
<div class="modal fade show d-block" *ngIf="showModal" tabindex="-1" role="dialog" style="z-index: 1050;">
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <div>
          <h4 class="modal-title mb-1">Container Load Types</h4>
        </div>
        <button type="button" class="btn-close" (click)="close()" aria-label="Close"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        <!-- Title and Add Button -->
        <div class="mb-3">
          <div class="d-flex justify-content-between align-items-start mb-2">
            <div>
              <h5 class="mb-1">Container Load Types Management</h5>
              <p class="text-muted small mb-0">Manage container load types for shipping (e.g., FCL, LCL, 20FCL, 40FCL)</p>
            </div>
            <button class="btn btn-primary" (click)="openAddModal()">
              <i class="bi bi-plus-circle me-1"></i>Add Container Load Type
            </button>
          </div>
        </div>

        <!-- Search Bar -->
        <div class="row mb-3">
          <div class="col-md-6">
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-search"></i></span>
              <input
                type="text"
                class="form-control"
                placeholder="Search container load types..."
                [(ngModel)]="searchTerm"
                (input)="applyFilters()">
            </div>
          </div>
        </div>

        <!-- Data Table -->
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th>Label</th>
                <th>Code</th>
                <th>Category</th>
                <th>Notes</th>
                <th>Created At</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let loadType of filteredLoadTypes">
                <td><strong>{{ loadType.label }}</strong></td>
                <td><span class="badge bg-light text-dark">{{ loadType.code }}</span></td>
                <td>
                  <span class="badge" [ngClass]="{
                    'bg-success': loadType.category === 'SEA',
                    'bg-primary': loadType.category === 'AIR'
                  }">
                    {{ loadType.category }}
                  </span>
                </td>
                <td class="text-muted small">{{ loadType.notes }}</td>
                <td>{{ formatDate(loadType.createdAt) }}</td>
                <td>
                  <div class="btn-group btn-group-sm">
                    <button class="btn btn-outline-primary" (click)="editLoadType(loadType)" title="Edit">
                      <i class="bi bi-pencil"></i>
                    </button>
                    <button class="btn btn-outline-danger" (click)="deleteLoadType(loadType)" title="Delete">
                      <i class="bi bi-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
              <tr *ngIf="filteredLoadTypes.length === 0">
                <td colspan="6" class="text-center text-muted py-4">
                  No container load types found.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="close()">Close</button>
      </div>
    </div>
  </div>
</div>

<!-- Add/Edit Load Type Modal (Nested) -->
<div class="modal-backdrop fade show" *ngIf="showAddModal" style="z-index: 2000; background-color: rgba(0, 0, 0, 0.85);"></div>
<div class="modal fade show d-block" *ngIf="showAddModal" tabindex="-1" role="dialog" style="z-index: 2001;">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ isEditMode ? 'Edit' : 'Add New' }} Container Load Type</h5>
        <button type="button" class="btn-close" (click)="closeAddModal()"></button>
      </div>
      <div class="modal-body">
        <form>
          <!-- Label -->
          <div class="mb-3">
            <label class="form-label">Label <span class="text-danger">*</span></label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="formData.label"
              name="label"
              placeholder="Enter label"
              required
            />
          </div>

          <!-- Code -->
          <div class="mb-3">
            <label class="form-label">Code <span class="text-danger">*</span></label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="formData.code"
              name="code"
              placeholder="Enter code"
              required
            />
          </div>

          <!-- Category -->
          <div class="mb-3">
            <label class="form-label">Category <span class="text-danger">*</span></label>
            <select class="form-select" [(ngModel)]="formData.category" name="category" required>
              <option value="SEA">SEA</option>
              <option value="AIR">AIR</option>
            </select>
          </div>

          <!-- Notes -->
          <div class="mb-3">
            <label class="form-label">Notes</label>
            <textarea
              class="form-control"
              rows="3"
              [(ngModel)]="formData.notes"
              name="notes"
              placeholder="Enter notes (optional)"
            ></textarea>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeAddModal()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="saveLoadType()">
          {{ isEditMode ? 'Update' : 'Create' }}
        </button>
      </div>
    </div>
  </div>
</div>
